import React from 'react'
import { Input, Col, Row, Tooltip } from 'antd'
import { use, api } from 'xadmin'

export default ({ input, field }) => {

  const [ code, setCode ] = React.useState(null)
  const [ loading, setLoading ] = React.useState(false)
  const form = use('form')

  const getCodeImage = React.useCallback((force) => {
    const { submitFailed, submitting } = form.getState()
    if(!(force || (!submitting && submitFailed))) {
      return
    }

    const query = { 'height':80,'width':240,'captchaLen':4,'maxSkew':0.7,'dotCount':80 }
    setLoading(true)
    api({ name: 'core/auth/captcha' })
      .fetch('?query=' + JSON.stringify(query))
      .then(({ json }) => {
        form.change('captchaId', json.captchaId)
        setCode(json)
        setLoading(false)
      })
      .catch(err => {
        setLoading(false)
      })
  }, [ form ])

  React.useEffect(() => {
    getCodeImage(true)
    // submitting 和 submitFailed 变化就执行effect，但是要同时满足特定条件时才会更新验证码
    form.useEffect(({ submitFailed, submitting }) => {
      getCodeImage(false)
    }, [ 'submitFailed', 'submitting' ])
  }, [ ])

  return (
    <Row gutter={8}>
      <Col span={14}>
        <Input {...input} disabled={!(code && code)} {...field.attrs} autocomplete="off" />
      </Col>
      <Col span={10}>
        {code && code.data ? (
          <Tooltip title="点击刷新验证码">
            <img style={{ cursor: 'pointer', width: '100%' }} onClick={getCodeImage(true)} src={code.data} />
          </Tooltip>
        ) : null}
      </Col>
    </Row>
  )
}
